import React, { FC, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';
import { SidebarView } from 'src/shared';
import { SidebarMode } from 'src/shared/InfoSidebar/types';
import { useCurrentSidebar } from 'src/shared/InfoSidebar/hooks';
import TenderPreview from 'src/pages/TendersPage/Sidebars/TenderPreview';
import { useTranslation } from 'react-i18next';
import EcPreview from '../SearchBar/EcPreview';

export const ExpiringContractsPreview: FC = () => {
  const { t } = useTranslation();

  const sidebarState = useCurrentSidebar();

  const onClose = useCallback(() => {
    if (sidebarState && sidebarState.mp) {
      const { isMPUpdated, resetMPData } = sidebarState.mp;

      if (isMPUpdated) {
        resetMPData();
      }
    }
  }, [sidebarState]);

  const shouldUpdate = useMemo(
    () => sidebarState && sidebarState.mode === SidebarMode.EC_INFO && sidebarState.mp,
    [sidebarState]
  );

  const showTooltip = useMemo(
    () => shouldUpdate && sidebarState?.mp?.isMPUpdated,
    [shouldUpdate, sidebarState?.mp?.isMPUpdated]
  );

  return sidebarState ? (
    <SidebarView
      onClose={shouldUpdate ? onClose : undefined}
      closeBtnTooltip={showTooltip ? t('Tenders.closeAndUpdate') : undefined}
      className={classNames(styles.sidebar, {
        [styles.isOpen]: !!sidebarState
      })}
    >
      {sidebarState.mode === SidebarMode.PROCUREMENT_INFO && sidebarState.id && (
        <TenderPreview tenderId={sidebarState.id} />
      )}
      {sidebarState.mode === SidebarMode.EC_INFO && <EcPreview key={sidebarState.id} />}
    </SidebarView>
  ) : (
    <></>
  );
};

export default ExpiringContractsPreview;
